// WithAdminRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const WithAdminRoute = ({ children }) => {
  const { currentUser, userObjectId, userClaims, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if user is authenticated, has an object ID, and has admin claims
  if (!currentUser || !userObjectId || !userClaims || !userClaims.isAdmin) {
    // User not authenticated, not in database, or not an admin
    return <Navigate to="/unauthorized" />;
    // Alternatively, you could redirect to home or login:
    // return <Navigate to="/" />;
  }

  return children;
};

export default WithAdminRoute;
